module.exports = __webpack_public_path__ + "static/media/my-tickets.4d7f2fbe.svg";